import { ServiceQualityPageView } from '~/app/landing/operator/service-quality/ServiceQualityPageView';
import { useServiceQualityPage } from '~/app/landing/operator/service-quality/hooks/useServiceQualityPage';

export function ServiceQualityPageContainer() {
  const viewProps = useServiceQualityPage();
  return <ServiceQualityPageView {...viewProps} />;
}
